import { render } from "./IconBell.vue?vue&type=template&id=f8e796fe"
import script from "./IconBell.vue?vue&type=script&lang=js"
export * from "./IconBell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__